export default __webpack_public_path__ + "static/soracom-4dc96fabb0e844303ae53fae71de3cdf.svg";